import React, { useRef } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";

/** 커서를 자석처럼 끌어당기는 래퍼 */
export default function Magnetic({ children, strength = 0.35, className }) {
	const ref = useRef(null);
	const x = useSpring(useMotionValue(0), { stiffness: 260, damping: 18 });
	const y = useSpring(useMotionValue(0), { stiffness: 260, damping: 18 });

	const handleMove = (event) => {
		const rect = ref.current?.getBoundingClientRect();
		if (!rect) return;
		x.set((event.clientX - (rect.left + rect.width / 2)) * strength);
		y.set((event.clientY - (rect.top + rect.height / 2)) * strength);
	};

	return (
		<motion.div
			ref={ref}
			className={className}
			style={{ x, y }}
			onMouseMove={handleMove}
			onMouseLeave={() => {
				x.set(0);
				y.set(0);
			}}
		>
			{children}
		</motion.div>
	);
}
